import React from 'react';
import { SurveyElementBase, ReactElementFactory } from 'survey-react-ui';
import './FilePreviewComponent.css';

class FilePreviewComponent extends SurveyElementBase<any, any> {
  constructor (props: any) {
    super(props);
    this.state = {
      question: props.question,
    };
  }

  render () {
    const { question } = this.state;
    if (!question || !question.value) {
      return null;
    }
    const isReadOnly = question.isReadOnly || (question.survey && question.survey.readOnly);
    return (
      <div className='my-preview-container'>
        <div className='files-container'>
          {question.value.map((fileItem: any) => (
            <div
              key={fileItem.name}
              className='button-container'
            >
              <div
                className='btn btn--choose'
              >
                {fileItem.name}
              </div>
              <div
                className={`btn btn--remove ${isReadOnly ? 'disabled' : ''}`}
                style={{
                  cursor: isReadOnly ? 'not-allowed' : 'pointer',
                  opacity: isReadOnly ? 0.5 : 1,
                }}
                title='Remove file'
                onClick={() => !isReadOnly && question.removeFile(fileItem.name)}
              >
                {'X'}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export const registerFilePreviewComponent = () => {
  ReactElementFactory.Instance.registerElement('sv-file-preview', (props) => {
    return React.createElement(FilePreviewComponent, props);
  });
};
